import { render, staticRenderFns } from "./reply-item.vue?vue&type=template&id=ab3bc50e&scoped=true&"
import script from "./reply-item.vue?vue&type=script&lang=js&"
export * from "./reply-item.vue?vue&type=script&lang=js&"
import style0 from "./reply-item.vue?vue&type=style&index=0&id=ab3bc50e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3bc50e",
  null
  
)

export default component.exports